export interface CommunityHero {
  title: string;
  subtitle: string;
  mascotImage: string;
  mascotAlt: string;
}

export interface CommunitySocialChannel {
  id: string;
  platform: 'whatsapp' | 'instagram' | 'facebook' | 'tiktok';
  name: string;
  handle: string;
  description: string;
  url: string;
  cta: string;
}

export interface CommunityBlogCard {
  title: string;
  category: string;
  categoryColor: string;
  date: string;
  image: string;
  excerpt: string;
  url: string;
}

export interface CommunityStat {
  value: string;
  label: string;
}

export interface CommunityData {
  hero: CommunityHero;
  social: {
    title: string;
    subtitle: string;
    whatsapp: CommunitySocialChannel;
    channels: CommunitySocialChannel[];
  };
  /** Cabecera de «¿Con quién jugar?»: los juegos, las provincias y los jugadores son reales (B11 J1). */
  playerFinder: {
    title: string;
    subtitle: string;
  };
  blog: {
    title: string;
    subtitle: string;
    cards: CommunityBlogCard[];
    cta: { label: string; url: string };
  };
  stats: {
    title: string;
    items: CommunityStat[];
  };
  newsletter: {
    title: string;
    subtitle: string;
    placeholder: string;
    buttonLabel: string;
  };
  cta: {
    title: string;
    subtitle: string;
    buttonLabel: string;
    buttonUrl: string;
  };
}

export const MOCK_COMMUNITY: CommunityData = {
  hero: {
    title: 'Encuentra tu tribu',
    subtitle:
      'Más de 2 000 jugadores costarricenses comprando, jugando y creciendo juntos. Tu lugar en la escena TCG local.',
    mascotImage: 'images/logo/community_lupa.png',
    mascotAlt: 'Mascota Perrón con lupa buscando jugadores',
  },
  social: {
    title: 'Dónde encontrarnos',
    subtitle:
      'Sígueme en el día a día de la tienda: aperturas, torneos, ofertas relámpago y la comunidad en movimiento.',
    whatsapp: {
      id: 'whatsapp',
      platform: 'whatsapp',
      name: 'Grupo de WhatsApp',
      handle: 'Más de 500 miembros activos',
      description:
        'Consultas, ofertas del día y torneos locales en tiempo real. El chat donde se mueve todo.',
      url: 'https://wa.me/50689125220',
      cta: 'Unirse al grupo',
    },
    channels: [
      {
        id: 'instagram',
        platform: 'instagram',
        name: 'Instagram',
        handle: '@perronstorecr',
        description: 'Pulls, aperturas y colecciones.',
        url: 'https://instagram.com/perronstorecr',
        cta: 'Seguir →',
      },
      {
        id: 'facebook',
        platform: 'facebook',
        name: 'Facebook',
        handle: 'Perrón Store CR',
        description: 'Eventos, torneos y novedades.',
        url: 'https://www.facebook.com/profile.php?id=100072122377020',
        cta: 'Seguir página →',
      },
      {
        id: 'tiktok',
        platform: 'tiktok',
        name: 'TikTok',
        handle: '@perronstorecr',
        description: 'Reseñas, decks y tips rápidos.',
        url: 'https://www.tiktok.com/@perronstorecr',
        cta: 'Ver videos →',
      },
    ],
  },
  playerFinder: {
    title: '¿Con quién jugar?',
    subtitle:
      'Encuentra jugadores cerca de ti, filtra por juego y provincia, y organiza partidas.',
  },
  blog: {
    title: 'Desde el blog',
    subtitle: 'Guías, estrategias y novedades de la comunidad TCG.',
    cards: [
      {
        title: 'Guía para armar tu primer deck de Magic en Costa Rica',
        category: 'Magic',
        categoryColor: '#5D4E8C',
        date: '28 marzo 2026',
        image: 'images/demo/blog/comunidad-01.jpg',
        excerpt:
          'Todo lo que necesitas saber para empezar en MTG sin gastar de más: formato, cartas clave y dónde conseguirlas.',
        url: '/blog/guia-primer-deck-magic',
      },
      {
        title: 'Los mejores sobres de Pokémon del 2026 que están por llegar',
        category: 'Pokémon',
        categoryColor: '#FFCB05',
        date: '22 marzo 2026',
        image: 'images/demo/blog/comunidad-02.jpg',
        excerpt:
          'Repaso de los próximos lanzamientos de Pokémon TCG y por qué vale la pena reservarlos desde ya.',
        url: '/blog/sobres-pokemon-2026',
      },
      {
        title: 'Cómo organizar un torneo casero de One Piece TCG',
        category: 'One Piece',
        categoryColor: '#E21B26',
        date: '15 marzo 2026',
        image: 'images/demo/blog/comunidad-03.jpg',
        excerpt:
          'Reglas, premios y logística: la guía para montar tu primer torneo entre amigos sin complicaciones.',
        url: '/blog/torneo-casero-one-piece',
      },
    ],
    cta: { label: 'Ver todo el blog →', url: '/blog' },
  },
  stats: {
    title: 'Comunidad en números',
    items: [
      { value: '+4,500', label: 'seguidores en Instagram' },
      { value: '+3,960', label: 'likes en Facebook' },
      { value: '+4,000', label: 'pedidos en línea' },
      { value: '+2,000', label: 'usuarios registrados' },
    ],
  },
  newsletter: {
    title: 'No te pierdas nada',
    subtitle:
      'Ofertas exclusivas, spoilers de nuevos sets y contenido de la comunidad directo a tu correo.',
    placeholder: 'tu@correo.com',
    buttonLabel: 'Suscribirme',
  },
  cta: {
    title: 'Tu lugar en la comunidad Perrón',
    subtitle: 'Crea tu perfil, encuentra jugadores y empieza a jugar.',
    buttonLabel: 'Crear mi perfil',
    buttonUrl: '/perfil/comunidad',
  },
};
